$(function(){
  var r = $('input[name="支払い方法"]:checked').val();
    
  if(r === "クレジット"){
    $('.np-content').removeClass('show');
    $('.np-message').removeClass('show');
  }else if(r === "NP後払い"){
    $('.np-content').addClass('show');
    $('.np-message').addClass('show');
  }
  
  $('input[name="支払い方法"]').click(function() {
    var radio_value = $('input[name="支払い方法"]:checked').val();
    console.log(radio_value);
    if(radio_value === "クレジット"){
      $('.np-content').removeClass('show');
      $('.np-message').removeClass('show');
    }else if(radio_value === "NP後払い"){
      $('.np-content').addClass('show');
      $('.np-message').addClass('show');
    }
  })
  //サムネイル
  var sliderThumbnail = new Swiper('.slider-thumbnail', {
    slidesPerView: 6,
    spaceBetween: 12,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  //スライダー
  var slider = new Swiper('.slider', {
    thumbs: {
      swiper: sliderThumbnail
    }
  });


});